import login from './login';
import users from './users';
import storage from './storage';
import material from './material';
import menu from './menu';
import tags from './tags';


import category from './category';
import order from './order';
import comment from './comment';
import logs from './logs';
import settings from './settings';

export default {
    users,
    login,
    storage,
    material,
    menu,
    tags,
    
    order,
    comment,
    logs,
    settings,
    category
}